import { Injectable } from '@angular/core';

// Define la interfaz de MenuItem (asumo que está en '../shared/components/menu/menu.component')
export interface MenuItem {
  id?: string;
  title: string;
  url?: string;
  icon: string;
  children?: MenuItem[]; // Aunque ya no lo usaremos, lo mantenemos por si la interfaz lo requiere
}

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  // Define el menú principal, donde todos los ítems están en el nivel superior.
  private readonly mainMenu: MenuItem[] = [
    // Ítems de Rentas
    {
      id: 'calendario',
      title: 'Agenda',
      url: '/calendario-rentas',
      icon: 'calendar-number',
    },
    {
      id: 'reportes',
      title: 'Reportes',
      url: '/reportes',
      icon: 'document-text',
    },
    {
      id: 'equipos',
      title: 'Equipos',
      url: '/equipos',
      icon: 'videocam',
    },
    {
      title: 'Hospitales',
      url: '/settings',
      icon: 'business',
    },
    {
      id: 'catalogos',
      title: 'Catalogos',
      url: '/catalogos-rentas',
      icon: 'list',
    },
  ];

  /**
   * Método público para obtener el único menú disponible (estructura aplanada).
   * @returns Estructura de menú completa.
   */
  getMenu(): MenuItem[] {
    return this.mainMenu;
  }
}
